export default "__VITE_ASSET__DDLUO55A__"